/* eslint-disable react/jsx-props-no-spreading */
import { Button, Col, Content, Row } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { useStyles } from './FatalError.styles'
import { ImageSpaceman } from './ImageSpaceman'

export const FatalError = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary: () => void
}): JSX.Element => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Content>
      <div className={classes.page404}>
        <Row vAlignCenter>
          <Col>
            <ImageSpaceman />
          </Col>

          <Col>
            <h1 className={classes.errorNumber}>{t('Shoot!')}</h1>
            <h2 className={classes.title}>
              {t('Well, this is unexpected...')}
            </h2>
            <div>
              <p>
                {t(
                  'An error occurred and we are working hard to fix the problem! If the problem persists, please contact the support.'
                )}
              </p>
            </div>

            <div className={classes.homeButton}>
              <Button
                buttonType="button"
                label={t('Try again')}
                type="action"
                onClick={resetErrorBoundary}
              />
            </div>
          </Col>
        </Row>
      </div>
    </Content>
  )
}
